import { useCallback } from "react"
import DateFilter, { DateRangePreset } from "../activity/date-filter"
import { useAppDispatch, useAppSelector } from "../../hooks"
import {
  selectDateRangePreset,
  selectCustomDateStart,
  selectCustomDateEnd,
  setDateRangePreset,
  setCustomDateRange
} from "../../../redux/slices/conversations"

const ConversationsDateFilter = () => {
  const dispatch = useAppDispatch()
  const dateRangePreset = useAppSelector(selectDateRangePreset)
  const customDateStart = useAppSelector(selectCustomDateStart)
  const customDateEnd = useAppSelector(selectCustomDateEnd)

  const handleRangeChange = useCallback(
    (range: DateRangePreset, startDate?: Date, endDate?: Date) => {
      if (range === "custom" && startDate && endDate) {
        dispatch(
          setCustomDateRange({
            start: startDate.getTime(),
            end: endDate.getTime()
          })
        )
      } else {
        dispatch(setDateRangePreset(range))
      }
    },
    [dispatch]
  )

  const handleClear = useCallback(() => {
    dispatch(setDateRangePreset("all"))
  }, [dispatch])

  return (
    <DateFilter
      selectedRange={dateRangePreset}
      customStartDate={customDateStart ? new Date(customDateStart) : null}
      customEndDate={customDateEnd ? new Date(customDateEnd) : null}
      onRangeChange={handleRangeChange}
      onClearFilter={handleClear}
      hideLabelOnMobile
    />
  )
}

export default ConversationsDateFilter
